
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { HelpService } from '@/services'
@Component({
    components: {}
})
export default class extends Vue {
    private typeId = -1
    private loading = false
    private isLoading = true

    private async mounted() {
        this.typeId = +this.$route.params.id
        const exist = await this.getDetail()
        this.isLoading = false
        if (!exist) this.$merror('找不到该分类!')
    }

    private form = {
        name: ''
    }
    private rules = {
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }]
    }
    get formRef() {
        return this.$refs.createTypeRef as ElForm
    }

    async getDetail() {
        const result = await HelpService.getArticleTypes({})
        let isExist = false
        if (result.status === 200) {
            if (result.data.length) {
                result.data.map((type: any) => {
                    if (+type.id === this.typeId) {
                        this.$set(this.form, 'name', type.name)
                        isExist = true
                    }
                })
            }
        }
        return isExist
    }

    onEdit() {
        this.formRef.validate(async valid => {
            if (valid) {
                const params = {
                    id: this.typeId,
                    name: this.form.name
                }
                this.loading = true
                const result = await HelpService.updateArticleType(params)
                if (result.status === 200) {
                    this.$msuccess('修改成功!')
                }
                this.loading = false
            }
        })
    }
}
